const CUSTOMER_INFO_UPDATED_EVENT_NAME = "CUSTOMER_INFO_UPDATED"
export {CUSTOMER_INFO_UPDATED_EVENT_NAME};